import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, MaskLine } from "@/components/Reveal";
import { EVENTS, IMG } from "@/data/site";

const ParallaxImg = ({ src, alt, className }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <div ref={ref} className={`img-zoom overflow-hidden border border-white/10 ${className}`}>
      <motion.img style={{ y, scale: 1.15 }} src={src} alt={alt} loading="lazy" className="w-full h-full object-cover" />
    </div>
  );
};

export const Events = () => (
  <section id="events" data-testid="events" className="relative py-32 sm:py-44 border-t border-white/5">
    <div className="max-w-screen-2xl mx-auto px-6 sm:px-10">
      <Reveal><p className="label mb-6">Weddings & Events</p></Reveal>
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <h2 className="lg:col-span-7 font-serif font-light text-4xl sm:text-6xl lg:text-7xl tracking-tight uppercase leading-[0.98]">
          <MaskLine>Momente, die</MaskLine>
          <MaskLine delay={0.08} className="text-[#d4c4a8] italic">nur einmal passieren.</MaskLine>
        </h2>
        <Reveal delay={0.1} className="lg:col-span-4 lg:col-start-9">
          <p className="font-body text-[#a1a1aa] leading-relaxed">
            Hochzeiten, Konzerte, Live-Events und Bühnenmomente — filmisch festgehalten mit
            Multicam-Setups und einem Gespür für den richtigen Augenblick.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 h-auto">
        <ParallaxImg src={IMG.weddingArch} alt="Hochzeitsvideografie Hamburg" className="aspect-[3/4] lg:row-span-2 lg:h-full" />
        <ParallaxImg src={IMG.concertRed} alt="Konzert Aufnahme Hamburg" className="aspect-[4/3]" />
        <ParallaxImg src={IMG.weddingStage} alt="Event Videografie Hamburg" className="aspect-[4/3]" />
        <ParallaxImg src={IMG.microphone} alt="Live Performance Recording" className="aspect-[4/3]" />
        <ParallaxImg src={IMG.crowd} alt="Eventproduktion Hamburg" className="aspect-[4/3]" />
      </div>

      <div className="mt-14 flex flex-wrap gap-x-6 gap-y-3">
        {EVENTS.map((e, i) => (
          <motion.span
            key={e}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.04 }}
            data-testid={`event-tag-${i}`}
            className="font-display uppercase tracking-[0.18em] text-xs text-[#a1a1aa] border border-white/10 px-4 py-2 hover:border-[#d4c4a8]/40 hover:text-[#d4c4a8] transition-colors duration-400"
          >
            {e}
          </motion.span>
        ))}
      </div>
    </div>
  </section>
);
